import { useContentStatusNotification } from '@lumapps/contents/hooks/useContentStatusNotification';

/** WARNING DO NOT USE: Only used to call the useContentStatusNotification hook in legacy */
export const ContentStatusNotification = ({ contentId, isNotificationDisplayable }) => {
    useContentStatusNotification({ contentId, isNotificationDisplayable });

    return null;
};
